import { render, staticRenderFns } from "./view-purchase.vue?vue&type=template&id=313669dc&scoped=true"
import script from "./view-purchase.vue?vue&type=script&lang=js"
export * from "./view-purchase.vue?vue&type=script&lang=js"
import style0 from "./view-purchase.vue?vue&type=style&index=0&id=313669dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313669dc",
  null
  
)

export default component.exports